module.exports = __webpack_public_path__ + "img/location-pin.aaf06139.svg";